import { HttpClient } from '@adapters/HttpClient';

export interface SignedContract {
    envelope_id: string;
    status_changed_date_time: string;
    sent_date_time: string;
    status: string;
    email?: string;
    name?: string;
    'status-signer'?: string;
}

export class SignedContractsApiAdapter {
    constructor(private httpClient: HttpClient) {}

    async getSignedContracts(email: string): Promise<SignedContract[]> {
        const response = await this.httpClient.get<SignedContract[]>('/contracts/get-signed', { email });
        return Array.isArray(response) ? response : [];
    }
}

